/**
 * Collection top: description read-more clamp and category slider arrows.
 */
(function () {
    // Loaded by both the Collection Top and Collection Hero sections;
    // a second run would double the delegated click handlers.
    var root = document.documentElement;
    if (root.hasAttribute('data-collection-top-ready')) return;
    root.setAttribute('data-collection-top-ready', '');

    var READ_MORE_TOLERANCE_PX = 1;
    var descriptionHeightCache = new WeakMap();
    var fontVersion = 0;
    var pendingReadMoreRoots = new Set();
    var readMoreFrame = 0;
    var measurementFrame = 0;

    /**
     * Full layout height of description at the same width as the live block, without line-clamp.
     * scrollHeight on the clamped box is unreliable (e.g. child margins, webkit-box quirks).
     */
    function descriptionLayoutInputs(inner, computed) {
      var width = inner.offsetWidth;
      var typography = [
        computed.fontFamily, computed.fontSize, computed.fontWeight, computed.fontStyle,
        computed.fontStretch, computed.fontVariant, computed.lineHeight,
        computed.letterSpacing, computed.wordSpacing, computed.textTransform,
        computed.textIndent, computed.whiteSpace, computed.writingMode,
        computed.paddingTop, computed.paddingRight, computed.paddingBottom, computed.paddingLeft,
        computed.boxSizing, computed.getPropertyValue('font-feature-settings'),
        computed.getPropertyValue('font-variation-settings'), computed.getPropertyValue('text-wrap'),
        computed.getPropertyValue('overflow-wrap'), computed.getPropertyValue('word-break')
      ].join('|');
      return {
        width: width, viewportWidth: window.innerWidth, html: inner.innerHTML,
        className: inner.className, typography: typography, fontVersion: fontVersion
      };
    }

    function sameDescriptionLayout(a, b) {
      return a && a.width === b.width && a.viewportWidth === b.viewportWidth &&
        a.html === b.html && a.className === b.className &&
        a.typography === b.typography && a.fontVersion === b.fontVersion;
    }

    function collectionDescriptionMeasurement(inner, computed) {
      var inputs = descriptionLayoutInputs(inner, computed);
      if (inputs.width <= 0) return { inputs: inputs, height: 0 };
      var cached = descriptionHeightCache.get(inner);
      if (sameDescriptionLayout(cached, inputs)) return { inputs: inputs, height: cached.height };

      // Startup, font readiness and ResizeObserver can all check the same box. Only
      // append a measuring clone when its content or layout inputs have changed.
      var clone = inner.cloneNode(true);
      clone.className = inner.className;
      clone.style.cssText =
        'position:absolute;left:-99999px;top:0;width:' +
        inputs.width +
        'px;max-height:none;height:auto;overflow:visible;display:block;margin:0;visibility:hidden;pointer-events:none;-webkit-line-clamp:unset;-webkit-box-orient:unset';
      clone.style.setProperty(
        'text-wrap',
        (computed.getPropertyValue('text-wrap') || 'wrap').trim() || 'wrap'
      );
      clone.style.setProperty(
        'overflow-wrap',
        (computed.getPropertyValue('overflow-wrap') || 'normal').trim() || 'normal'
      );
      clone.style.setProperty(
        'word-break',
        (computed.getPropertyValue('word-break') || 'normal').trim() || 'normal'
      );
      // Keep the same rich-text measurement, but append only after every block's
      // layout inputs have been read. Its height is read in the following frame.
      return { inputs: inputs, clone: clone };
    }

    function debounce(fn, ms) {
      var t;
      return function() {
        clearTimeout(t);
        var args = arguments;
        t = setTimeout(function() {
          fn.apply(null, args);
        }, ms);
      };
    }

    function getReadMoreLineCount(readMore) {
      var root = readMore.closest('.collection-header-default') || readMore;
      var styles = getComputedStyle(root);
      var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      var lines = parseInt(
        styles.getPropertyValue(
          isDesktop ? '--collection-read-more-lines-desktop' : '--collection-read-more-lines-mobile'
        ),
        10
      );
      if (isNaN(lines) || lines < 1) lines = 3;
      return lines;
    }

    /**
     * Show Read more only when collapsed text overflows the line clamp (layout-based).
     * Wide viewports: if all copy fits within the configured lines, the control stays hidden; resize rechecks.
     */
    function prepareReadMore(blocks) {
      var plans = [];
      blocks.forEach(function(readMore) {
        if (!readMore.isConnected) return;
        var inner = readMore.querySelector('.collection-header-default__description-inner');
        var button = readMore.querySelector('[data-read-more-button]');
        if (!inner || !button) return;
        var plan = { readMore: readMore, inner: inner, button: button };
        plans.push(plan);

        if (readMore.classList.contains('is-expanded')) {
          plan.expanded = true;
          return;
        }

        var raw = inner.textContent || '';
        if (!/\S/.test(raw)) {
          plan.blank = true;
          return;
        }

        var innerStyles = getComputedStyle(inner);
        plan.measurement = collectionDescriptionMeasurement(inner, innerStyles);
        var maxCollapsedPx = parseFloat(innerStyles.maxHeight);
        if (isNaN(maxCollapsedPx) || maxCollapsedPx <= 0) {
          var fs = parseFloat(innerStyles.fontSize) || 14;
          var lhRaw = innerStyles.lineHeight;
          var lh = parseFloat(lhRaw);
          if (isNaN(lh)) {
            lh = fs * 1.5;
          } else if (lhRaw.indexOf('px') === -1 && lh < 10) {
            lh = fs * lh;
          }
          maxCollapsedPx = lh * getReadMoreLineCount(readMore);
        }

        plan.maxCollapsedPx = maxCollapsedPx;
        plan.maxHeight = innerStyles.maxHeight;
      });
      return plans;
    }

    function finishReadMore(plans, validate) {
      // Read every clone before removing any or changing button/classes. In the
      // normal frame pipeline, layout for the appended clones is already ready.
      plans.forEach(function(plan) {
        var readMore = plan.readMore, inner = plan.inner;
        if (!readMore.isConnected) return;
        if (!inner.isConnected ||
            readMore.querySelector('.collection-header-default__description-inner') !== inner ||
            readMore.querySelector('[data-read-more-button]') !== plan.button) {
          pendingReadMoreRoots.add(readMore);
          return;
        }
        if (readMore.classList.contains('is-expanded')) { plan.show = true; return; }
        if (!/\S/.test(inner.textContent || '')) { plan.show = false; return; }
        var measurement = plan.measurement;
        var styles = validate && measurement ? getComputedStyle(inner) : null;
        if (!measurement || (validate &&
            (!sameDescriptionLayout(measurement.inputs, descriptionLayoutInputs(inner, styles)) ||
             styles.maxHeight !== plan.maxHeight))) {
          pendingReadMoreRoots.add(readMore);
          return;
        }
        if (measurement.clone) {
          if (measurement.clone.parentNode !== inner.parentNode) {
            pendingReadMoreRoots.add(readMore);
            return;
          }
          measurement.height = measurement.clone.scrollHeight;
          var cached = measurement.inputs;
          cached.height = measurement.height;
          descriptionHeightCache.set(inner, cached);
        }
        plan.overflow = measurement.height > plan.maxCollapsedPx + READ_MORE_TOLERANCE_PX;
        plan.show = plan.overflow;
      });
      plans.forEach(function(plan) {
        var clone = plan.measurement && plan.measurement.clone;
        if (clone && clone.parentNode) clone.parentNode.removeChild(clone);
        if (plan.show === undefined) return;
        if (plan.overflow !== undefined) {
          plan.readMore.classList.toggle('has-read-more', plan.overflow);
        }
        if (plan.show) plan.button.removeAttribute('hidden');
        else plan.button.setAttribute('hidden', '');
      });
      queueReadMoreFrame();
    }

    function queueReadMoreFrame() {
      if (readMoreFrame || measurementFrame || !pendingReadMoreRoots.size) return;
      readMoreFrame = requestAnimationFrame(function() {
        readMoreFrame = 0;
        var roots = pendingReadMoreRoots.has(document) ? [document] : Array.from(pendingReadMoreRoots);
        pendingReadMoreRoots.clear();
        var blocks = new Set();
        roots.forEach(function(scope) {
          if (scope.isConnected === false) return;
          if (scope.matches && scope.matches('[data-read-more]')) blocks.add(scope);
          else scope.querySelectorAll('[data-read-more]').forEach(function(block) { blocks.add(block); });
        });
        var plans = prepareReadMore(blocks);
        var hasClones = false;
        plans.forEach(function(plan) {
          var clone = plan.measurement && plan.measurement.clone;
          if (clone) { plan.inner.parentNode.appendChild(clone); hasClones = true; }
        });
        if (!hasClones) { finishReadMore(plans, false); return; }
        measurementFrame = requestAnimationFrame(function() {
          measurementFrame = 0;
          finishReadMore(plans, true);
        });
      });
    }

    function scheduleReadMore(root) {
      pendingReadMoreRoots.add(root);
      queueReadMoreFrame();
    }

    // Observing the blocks also covers window resizes.
    var readMoreObserver = new ResizeObserver(
      debounce(function() {
        scheduleReadMore(document);
      }, 100)
    );

    /** Arrows only show (CSS keys off data-overflowing) when the pills are wider than the track. */
    function updateCategoryTrackOverflow(track) {
      var wrapper = track.closest('.collection-header-default__category-slider-wrapper');
      if (wrapper) wrapper.toggleAttribute('data-overflowing', track.scrollWidth > track.clientWidth + 1);
    }

    // Fires once on observe(), so it also sets the initial state.
    var trackObserver = new ResizeObserver(function(entries) {
      entries.forEach(function(entry) {
        updateCategoryTrackOverflow(entry.target);
      });
    });

    function init(root) {
      scheduleReadMore(root);
      root.querySelectorAll('[data-read-more]').forEach(function(block) {
        readMoreObserver.observe(block);
      });
      root.querySelectorAll('[data-category-slider-track]').forEach(function(track) {
        trackObserver.observe(track);
      });
    }

    function start() {
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          init(document);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    // Font swaps change text widths without resizing the observed boxes.
    // Coalesce nearby font notifications before invalidating cached measurements.
    var fontRefreshTimer = 0;
    function queueFontRefresh() {
      if (fontRefreshTimer) return;
      fontRefreshTimer = setTimeout(function() {
        fontRefreshTimer = 0;
        fontVersion += 1;
        scheduleReadMore(document);
        document.querySelectorAll('[data-category-slider-track]').forEach(updateCategoryTrackOverflow);
      }, 50);
    }
    if (document.fonts) {
      document.fonts.ready.then(queueFontRefresh);
      document.fonts.addEventListener('loadingdone', queueFontRefresh);
    }

    document.addEventListener('shopify:section:load', function(e) {
      requestAnimationFrame(function() {
        init(e.target);
      });
    });

    // Read more / Read less – only the control toggles (not clicks on description body / links)
    document.addEventListener('click', function(e) {
      var toggleBtn = e.target.closest('[data-read-more-button]');
      if (toggleBtn) {
        var readMore = toggleBtn.closest('[data-read-more]');
        if (!readMore) return;
        readMore.classList.toggle('is-expanded');
        toggleBtn.setAttribute('aria-expanded', readMore.classList.contains('is-expanded'));
        var buttonText = readMore.querySelector('.read-more__button-text');
        if (buttonText) buttonText.textContent = readMore.classList.contains('is-expanded') ? 'Read Less' : 'Read More';
        // The toggle, label and ARIA state respond in the click handler. Only a
        // stale collapsed-height measurement waits for the batched layout pass.
        if (readMore.classList.contains('is-expanded')) toggleBtn.removeAttribute('hidden');
        scheduleReadMore(readMore);
        return;
      }
      // Category slider arrows – delegation so it works even if section loads after DOMContentLoaded
      var arrow = e.target.closest('[data-category-slider-arrow]');
      if (!arrow) return;
      e.preventDefault();
      e.stopPropagation();
      var wrapper = arrow.closest('.collection-header-default__category-slider-wrapper');
      var track = wrapper && wrapper.querySelector('[data-category-slider-track]');
      if (!track) return;
      var card = track.querySelector('.collection-header-default__category-card');
      var step = card
        ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0)
        : track.clientWidth;
      track.scrollBy({ left: arrow.getAttribute('data-direction') === 'left' ? -step : step, behavior: 'smooth' });
    });
  })();
